<template>
  <admin-card title="Статистика пользователя" :showPartnersBlock="false">
    <table class="table table-striped table-bordered admin-table" v-if="stats">
      <thead>
      <tr>
        <th>Действие</th>
        <th>Время</th>
        <th>Ссылка</th>
        <th>IP</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="stat in stats">
        <td>{{ stat.label }}</td>
        <td>{{ stat.created_at }}</td>
        <td>{{ stat.link }}</td>
        <td>{{ stat.ip }}</td>
      </tr>
      </tbody>
    </table>
  </admin-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import AdminPage from "../admin-page";

  export default {
    metaInfo () {
      return { title: 'Статистика пользователя' }
    },
    extends: AdminPage,
    computed: mapGetters({
      stats: 'users/statistics'
    }),
    data: () => ({
      // stats: []
    }),
    methods: {
    },
    mounted() {
    },
    async beforeMount () {
      const userId = parseInt(this.$route.params.id);
      await this.$store.dispatch('users/getStats', userId);
    },
    beforeDestroy() {
      this.$store.dispatch('users/clearStats');
    }
  }
</script>
